export default [
    {
        path: '/pages/affiliate/affiliateWithdrawalManage',
        name: '/pages/affiliate/affiliateWithdrawalManage',
        component: () => import('@/views/affiliate/affiliateWithdrawalManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateVisitManage',
        name: '/pages/affiliate/affiliateVisitManage',
        component: () => import('@/views/affiliate/affiliateVisitManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserManage',
        name: '/pages/affiliate/affiliateUserManage',
        component: () => import('@/views/affiliate/affiliateUserManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserDetail',
        name: '/pages/affiliate/affiliateUserDetail',
        component: () => import('@/views/affiliate/affiliateUserDetail.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserAuditManage',
        name: '/pages/affiliate/affiliateUserAuditManage',
        component: () => import('@/views/affiliate/affiliateUserAuditManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateRuleManage',
        name: '/pages/affiliate/affiliateRuleManage',
        component: () => import('@/views/affiliate/affiliateRuleManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateRelationManage',
        name: '/pages/affiliate/affiliateRelationManage',
        component: () => import('@/views/affiliate/affiliateRelationManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateProductManage',
        name: '/pages/affiliate/affiliateProductManage',
        component: () => import('@/views/affiliate/affiliateProductManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateCommissionManage',
        name: '/pages/affiliate/affiliateCommissionManage',
        component: () => import('@/views/affiliate/affiliateCommissionManage.vue')
    }
]
